export default __webpack_public_path__ + "static/1318-e5ae08ad6a9467b9b383fbbf74648f6f.gif";